import { findInTree } from '../preload/utils/trees.js'
import categories from '../preload/data/categories.json'
import config from '../preload/data/config.json'

export function getBlogCategory () {
  return findInTree({ children: categories }, 'id', config?.gesundheitsthemen_kategorie?.id)
}
